/**
 * No-JS fallback disabler — Level 2 registered component (CSP build:
 * inline expressions can't hold this logic).
 *
 * Form primitives that render BOTH a JS-enhanced control and a no-js-only
 * native fallback (select-field, multi-select-field) hide the fallback
 * with CSS when JS runs — but CSS-hidden controls still participate in
 * constraint validation AND submission, so an empty required fallback
 * silently blocks submits ("not focusable") and its empty value clobbers
 * the JS path's hidden input (same name, later in the DOM). Disabling
 * the fallback controls at Alpine init removes them from both. Without
 * JS, Alpine never runs and the fallback stays fully functional.
 */
export default function nojsFallback() {
    return {
        init() {
            this.$el.querySelectorAll('select, input, textarea').forEach((el) => {
                el.disabled = true;
            });
        },
    };
}
